/**
 * iOS requires a touch start handler for the :active pseudo-class to work.
 * This may be on either the element, the document, or on any (?) ancestor.
 * Note that React has its own event system that attaches event handlers to
 * the document (React 16) or root node (React 17). This may cause :active
 * to work even for elements that don't listen for touch events.
 *
 * The touch event handler can be a no-op. This hook returns a function
 * that does nothing but forward the event to an optional input handler.
 *
 * See also: https://stackoverflow.com/a/33681490.
 */
var useiOSActiveState = function (onTouchStart) {
    return function (e) {
        return onTouchStart === null || onTouchStart === void 0 ? void 0 : onTouchStart(e);
    };
};

export default useiOSActiveState;
